import { StrictMode, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import './styles/app.css'
import { initFaro } from './faro'
import { api } from './api'
import { BagProvider } from './store'
import { Header } from './components/Header'
import { Footer } from './components/Footer'
import { Toaster } from './components/Toast'
import { Home } from './pages/Home'
import { Category } from './pages/Category'
import { Product } from './pages/Product'
import { Bag } from './pages/Bag'
import { Checkout } from './pages/Checkout'
import { Confirmation } from './pages/Confirmation'
import { NotFound } from './pages/NotFound'

initFaro()

function pageName(path: string): string {
  if (path === '/') return 'home'
  if (path.startsWith('/product/')) return 'product'
  if (path === '/bag') return 'bag'
  if (path === '/checkout') return 'checkout'
  if (path.startsWith('/order/')) return 'confirmation'
  if (path.startsWith('/search')) return 'search'
  if (['/women', '/men', '/new', '/sale'].includes(path)) return 'category'
  return 'other'
}

function PageViews() {
  const loc = useLocation()
  useEffect(() => { void api.pageview(pageName(loc.pathname)); window.scrollTo({ top: 0 }) }, [loc.pathname])
  return null
}

function App() {
  return (
    <BrowserRouter>
      <BagProvider>
        <PageViews />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/women" element={<Category />} />
            <Route path="/men" element={<Category />} />
            <Route path="/new" element={<Category />} />
            <Route path="/sale" element={<Category />} />
            <Route path="/search" element={<Category />} />
            <Route path="/product/:id" element={<Product />} />
            <Route path="/bag" element={<Bag />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/order/:id" element={<Confirmation />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BagProvider>
    </BrowserRouter>
  )
}

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>)
